/**
 * Magento Integration Registration
 * Registers the Magento integration with the integration registry
 */

import { IntegrationRegistry } from '../registry/IntegrationRegistry';
import { MagentoIntegrationFactory } from './MagentoIntegrationFactory';

export function registerMagentoIntegration(): void {
  const registry = IntegrationRegistry.getInstance();
  
  registry.register(
    'ecommerce:magento',
    'Magento 2',
    'ecommerce',
    'magento',
    '1.0.0',
    new MagentoIntegrationFactory()
  );
}